<template>
  <el-col>
    <el-row type="flex" justify="center" align="middle" :style="{ height: `${distLinesHeight}px` }">
      <div style="display: inline-block; margin-right: 12px;">
        <el-icon class="is-loading"><Loading/></el-icon>
      </div>
      <div style="display: inline-block;">
        Loading Distribution Lines, please wait...
      </div>
    </el-row>
  </el-col>
</template>

<script>
  export default {
    props: {
      distLinesHeight: Number
    }
  }
</script>
